import React, { useMemo } from 'react';
import { IUser } from '@shared/context/current-user';
import useStyles from './styles';
import { Avatar, Tooltip } from '@material-ui/core';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';

interface componentProps {
  onClick?: () => void;
}

const UserLogo = ({ onClick }: componentProps) => {
  const classes = useStyles();
  const { restaurant } = useKeycloakUserState();

  const userData = useMemo<IUser | null>(() => {
    return restaurant;
  }, [restaurant]);

  return (
    <Tooltip title={`${userData?.name}`} onClick={onClick}>
      {userData?.logoUrl ? (
        <div
          id="user-logo"
          className={`${classes.userLogoBox} user-logo`}
          role="img"
          aria-label={`Logo image of the ${userData?.name}`}
        >
          <span
            className={classes.userLogoImage}
            style={{
              backgroundImage: `url(${userData?.logoUrl})`,
            }}
          >
            Logo image of the {userData?.name}
          </span>
        </div>
      ) : (
        <div className={classes.avatarLetterBox}>
          <Avatar>{userData?.name ? userData?.name.charAt(0).trim() : ''} </Avatar>
        </div>
      )}
    </Tooltip>
  );
};

export default UserLogo;
